
export const SITE_CONFIG = {
  companyName: {
    zh: "上海爱优企服会展有限公司",
    en: "SHANGHAI AUCHIEF EXPO CO.,LTD",
    ru: "ООО «АУЧИФ ЭКСПО» (Шанхай)"
  },

  email: "info@auchief.com",
  phone: "4008-499-007",
  offices: [
    {
      id: "longcheng",
      city: { zh: "莫斯科", en: "Moscow", ru: "Москва" },
      address: {
        zh: "俄罗斯龙城国际数字电商科技园",
        en: "Longcheng International Technology Park of Digital E-Commerce, 56, Section 1, Verkhnie Polya, Russia",
        ru: "Международный технологический парк цифровой электронной коммерции Лунчэн, Россия, Верхние поля 56 с1"
      }
    },
    {
      id: "greenwood",
      city: { zh: "莫斯科", en: "Moscow", ru: "Москва" },
      address: {
        zh: "格林伍德办公室",
        en: "Section 33, Greenwood Territory, Putilkovo Urban-Type Settlement, Krasnogorsk Urban District, Moscow Oblast, 143440, Russia",
        ru: "территория Гринвуд, с33, посёлок городского типа Путилково, городской округ Красногорск, Московская область, 143440"
      }
    },
    {
      id: "shanghai",
      city: { zh: "上海", en: "Shanghai", ru: "Шанхай" },
      address: {
        zh: "中国上海市闵行区莘建东路绿地科技岛广场c座304室",
        en: "Room 304, Building C, Greenland Technology Island Plaza, East Xinjian Road, Minhang District, Shanghai, China",
        ru: "Помещение 304, Здание С, Площадь «Зеленый Ланд Технологический Остров», Восточная улица Синьцзянь, Район Миньхан, Шанхай, Китай"
      }
    }
  ],
  socials: [
    {
      platform: "抖音",
      id: "aiyou_douyin",
      url: "https://v.douyin.com/esLr7MYWxaQ/",
      type: "link",
      icon: "M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.59-1.01V14.5c0 1.5-.4 3.04-1.38 4.22-1.29 1.56-3.39 2.33-5.39 2.02-2.31-.36-4.28-2.31-4.63-4.63-.44-2.73 1.39-5.45 4.04-6.18.52-.14 1.07-.2 1.61-.2V13.8c-.85.06-1.74.45-2.3 1.1-.73.86-.81 2.14-.19 3.07.67.99 2 1.43 3.12 1.11.96-.27 1.67-1.12 1.83-2.11.08-.52.07-1.04.07-1.56V0l.02.02z",
      color: "#000000"
    },
    {
      platform: "小红书",
      id: "aiyou_xhs",
      url: "https://xhslink.com/m/7AL0yjpgR9L",
      type: "link",
      icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.12 13.5c-.38.75-1.12 1.25-1.88 1.5-1.12.38-2.38.38-3.5 0-.75-.25-1.5-.75-1.88-1.5-.38-.75-.5-1.62-.5-2.5 0-.88.12-1.75.5-2.5.38-.75 1.12-1.25 1.88-1.5 1.12-.38 2.38-.38 3.5 0 .75.25 1.5.75 1.88 1.5.38.75.5 1.62.5 2.5 0 .88-.12 1.75-.5 2.5zM12 9.5c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z",
      color: "#ff2442"
    }
  ],
  beian: {
    icp: "沪ICP备2026002817号",
    gongan: "沪公网安备31011202022031号"
  },
  features: {
    aiConsultant: false
  }
};
